import React from 'react';
import { Lock, Sparkles } from 'lucide-react';

const LABELS = {
  youtube: 'YouTube videos',
  reel:    'Reels',
  script:  'Scripts',
  audio:   'Audio files',
  image:   'Images',
};

/**
 * Compact free-tier usage indicator shown above a generate button.
 * Renders nothing if user is admin or paid (limits is null/limit unset).
 *
 * Props:
 *  - limits: response object from /api/usage/limits
 *  - category: 'youtube' | 'reel' | 'script' | 'audio' | 'image'
 *  - onUpgradeClick: () => void — called when user clicks the Upgrade link
 */
export default function UsageBadge({ limits, category, onUpgradeClick }) {
  if (!limits || !limits.is_free_tier) return null;
  const bucket = limits[category];
  if (!bucket || bucket.limit == null) return null;

  const reached = bucket.limit_reached;

  return (
    <div className={`flex items-center justify-between px-3 py-2 rounded-lg text-xs border ${
      reached
        ? 'bg-amber-500/10 border-amber-500/30 text-amber-300'
        : 'bg-zinc-800/40 border-zinc-700 text-zinc-400'
    }`} data-testid={`usage-badge-${category}`}>
      <span className="flex items-center gap-1.5">
        {reached ? <Lock className="w-3.5 h-3.5" /> : <Sparkles className="w-3.5 h-3.5" />}
        Free {LABELS[category] || category}: {bucket.used}/{bucket.limit}
      </span>
      {reached && (
        <button
          onClick={onUpgradeClick}
          className="text-amber-300 hover:text-amber-200 underline underline-offset-2 font-medium"
          data-testid={`usage-upgrade-link-${category}`}
        >
          Upgrade
        </button>
      )}
    </div>
  );
}
